import { components } from "ms-vtools";
import app from "./modules/app.js";
import exportPage from "./modules/exportPage.js";
import share from "./modules/share.js";

const routes = [
    ...share,
    {
        path: "/",
        name: "home",
        meta: {
            title: "首页"
        },
        component: () => import("@/App.vue"),
        children: [
            app
        ]
    },
    exportPage,
    {
        path: "/ssoLoginRedirect",
        name: "ssoLoginRedirect",
        meta: {
            title: "验证",
            norpermission: true
        },
        component: () => import("@/views/sso/ssoLoginRedirect.vue")
    },
    // 错误页面
    {
        path: "/500",
        name: "500",
        meta: {
            title: "500"
        },
        component: components.Error500
    },
    {
        path: "/403",
        name: "403",
        meta: {
            title: "403"
        },
        component: components.Error403
    },
    {
        path: "/*",
        name: "404",
        meta: {
            title: "404"
        },
        component: components.Error404
    }
];

export {
    routes
};



// WEBPACK FOOTER //
// ./src/router/routes.js